import { useMutation } from "@tanstack/react-query";
import { templateServices } from "./template.services";

export const useCreateTemplate = () => {
  return useMutation({
    mutationFn: templateServices.createTemplate,
  });
};

export const useUpdateTemplate = () => {
  return useMutation({
    mutationFn: templateServices.updateTemplate,
  });
};

export const useDeleteTemplate = () => {
  return useMutation({
    mutationFn: templateServices.deleteTemplate,
  });
};

export const useCreateRule = () => {
  return useMutation({
    mutationFn: templateServices.createRule,
  });
};

export const useUpdateRule = () => {
  return useMutation({
    mutationFn: templateServices.updateRule,
  });
};

export const useDeleteRule = () => {
  return useMutation({
    mutationFn: templateServices.deleteRule,
  });
};
